let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ihN58")).then(() => parcelRequire('5jo87'));